import React from 'react'
import { Button } from 'reactstrap'
import { BeatLoader } from 'react-spinners'

export default function ActionButton({ notInClass, loading, error,...rest}) {
  const color = !notInClass ? "danger" : "secondary";
  return (
    <Button color={color} className="btn-rounded-30 pull-right" {...rest}>
      <BeatLoader loading={loading} />
      {!!error && error}
      {notInClass && !error && '+'}
      {!notInClass && !error && '-'}
    </Button>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents/ActionButton.js